import { useUserStore } from "./redux-hooks/user-store/user.store";

interface IGtmEvent {
  eventName: string;
  [key: string]: any;
  eventProps?: {
    environment?: string;
    city?: string;
    clinic?: string;
    userId?:String;
    [key: string]: any;
  };
}

export const useGTM = () => {
  const { user } = useUserStore();

  const dispatchEvent = (params: IGtmEvent) => {
    (window as any).dataLayer.push({
      event: "gv.event",
      eventName: params.eventName,
      userId: user?.id || "",
      email: user?.email || params?.email || "",
      phone: `${user?.countryCode || ""}${user?.phone || ""}` || `1${params?.phone}` || "",
      eventProps: {
        ...params.eventProps,
        environment: process.env.REACT_APP_NODE_ENV! || "",
        city: user?.location?.city.toLowerCase().replace(/\s+/g, "_") ||
        params?.eventProps?.city?.replace(/\s+/g, "_") || "",
        clinic: user?.location?.locationName.toLowerCase()?.replace(/\s+/g, "_") ||
        params?.eventProps?.clinic?.replace(/\s+/g, "_") || "",
      },
    });
  };

  return {
    dispatchEvent,
  };
};
